import { useCallback } from 'react'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import TextLink from 'LuxKit/TextLink'
import useOfferPageDispatch from 'hooks/OfferPage/useOfferPageDispatch'
import { generateOfferPageRoom, OfferPageActions } from 'contexts/OfferPage/offerPageStateReducer'
import styled from 'styled-components'
import { rem } from 'polished'

export const EMBEDDED_TRAVELLING_SOLO_BANNER_HEIGHT = 36

const EmbeddedBannerContent = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(8)};
  width: 100%;
  font-size: ${rem(14)};
  line-height: ${rem(20)};

  > span {
    flex: 1;
    overflow: hidden;
    text-align: start;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  > a {
    flex-shrink: 0;
    margin-inline-start: auto;
  }
`

const EmbeddedBanner = styled.div`
  box-sizing: border-box;
  height: ${rem(EMBEDDED_TRAVELLING_SOLO_BANNER_HEIGHT)};
  padding: ${rem(8)} ${rem(20)};
  background-color: ${props => props.theme.palette.neutral.surface.lightBackground};
  color: ${props => props.theme.palette.neutral.surface.lightContrast};
`

function TravellingSoloBanner() {
  const offerPageDispatch = useOfferPageDispatch()

  const handleViewSoloPackages = useCallback((e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    offerPageDispatch({
      type: OfferPageActions.setRooms,
      rooms: [generateOfferPageRoom({ adults: 1, children: 0, infants: 0 })],
    })
  }, [offerPageDispatch])

  return (
    <EmbeddedBanner>
      <EmbeddedBannerContent>
        <span>
          <FormattedMessage
            id="AfPXtLoQtEvBVDa_Ff5B"
            defaultMessage="<strong>Travelling solo?</strong> Unlock special rates"
            description="Compact promotional banner text encouraging solo travellers to view special rates"
            values={{
              strong: (chunks: React.ReactNode) => <strong>{chunks}</strong>,
            }}
          />
        </span>
        <TextLink underline weight="regular" onClick={handleViewSoloPackages}>
          <FormattedMessage
            id="lPrwzlJE8a8omiMY7tEu"
            defaultMessage="View"
            description="Link text for viewing solo traveller packages from the compact banner"
          />
        </TextLink>
      </EmbeddedBannerContent>
    </EmbeddedBanner>
  )
}

export default React.memo(TravellingSoloBanner)
